import React from 'react';

import { moonPayApiKey } from '../../../config';

interface MoonPayModalProps {
  onClose: () => void;
  allowedCurrencies: string[];
}

export const MoonPay: React.FC<MoonPayModalProps> = () => {
  return (
    <div className="flex flex-row justify-center items-center h-full mt-20 lg:mt-0">
      <iframe
        title="moonpay"
        allow="accelerometer; autoplay; camera; gyroscope; payment"
        frameBorder="0"
        src={`https://buy.moonpay.com?apiKey=${moonPayApiKey}&showOnlyCurrencies=eth,bnb_bsc`}
        style={{
          maxWidth: '480px',
          maxHeight: '683px',
          width: '100%',
          height: '100%',
          borderRadius: '2%',
        }}
      />
    </div>
  );
};
